import { render, staticRenderFns } from "./questionnaire.vue?vue&type=template&id=15523b60&scoped=true&"
import script from "./questionnaire.vue?vue&type=script&lang=ts&"
export * from "./questionnaire.vue?vue&type=script&lang=ts&"
import style0 from "./questionnaire.vue?vue&type=style&index=0&id=15523b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15523b60",
  null
  
)

export default component.exports